import { BooleanQs } from '~/apiClient';

export const toBooleanAPIParam = (b: boolean): BooleanQs.true | undefined => (b ? BooleanQs.true : undefined);
